export interface IBounds {
    width: number;
    height: number;
}
export class Dimension {
    width: number;
    height: number;
    x: number;
    y: number;

    constructor(d: Dimension | null = null) {
        if (d) Object.assign(this, d);
    }

    toString() {
        return `(${CanvasUtils.round(this.x)}, ${CanvasUtils.round(this.y)}) - (${CanvasUtils.round(this.width)} x ${CanvasUtils.round(this.height)})`;
    }
}

export class CanvasUtils {

    static round(n: number) {
        return Math.round(n * 100) / 100;
    }

    static aspectRatioFor(box: IBounds): number {
        if (!box) return 1;
        if (box.height > 0) {
            return box.width / box.height;
        }
        return 1;
    }

    static centerBounds(inner: Dimension, outer: IBounds): Dimension {
        if (!inner) throw new Error(`inner must be provided`);
        if (outer) {
            inner.x = outer.width / 2 - inner.width / 2;
            inner.y = outer.height / 2 - inner.height / 2;
        }
        return new Dimension(inner);
    }

    static bestFit(inner: IBounds, outer: IBounds): Dimension {
        if (!outer) {
            throw new Error(`outer bounds must be provided`);
        }
        let outerBounds = { x: 0, y: 0, width: outer.width, height: outer.height };
        if (!inner) return outerBounds;

        let innerAspect = this.aspectRatioFor(inner);
        let outerAspect = this.aspectRatioFor(outer);
        if (innerAspect == outerAspect) return outerBounds;

        let outerMinor = Math.min(outer.width, outer.height);
        let outerMajor = Math.max(outer.width, outer.height);
        let innerMinor = Math.min(inner.width, inner.height);
        let innerMajor = Math.max(inner.width, inner.height);
        let final: Dimension;

        let nominalBounds: Dimension[] = [
            new Dimension({ x: 0, y: 0, width: outerMinor, height: outerMinor / innerAspect }),
            new Dimension({ x: 0, y: 0, width: outerMinor * innerAspect, height: outerMinor }),
            new Dimension({ x: 0, y: 0, width: outerMajor, height: outerMajor / innerAspect }),
            new Dimension({ x: 0, y: 0, width: outerMajor * innerAspect, height: outerMajor }),

            new Dimension({ x: 0, y: 0, width: innerMinor, height: innerMinor / innerAspect }),
            new Dimension({ x: 0, y: 0, width: innerMinor * innerAspect, height: innerMinor }),
            new Dimension({ x: 0, y: 0, width: innerMajor, height: innerMajor / innerAspect }),
            new Dimension({ x: 0, y: 0, width: innerMajor * innerAspect, height: innerMajor }),
        ];

        let boundsThatfit = nominalBounds.filter(b => b.width <= outer.width && b.height <= outer.height);

        boundsThatfit.sort((a, b) => {
            let size_a = a.width * a.height;
            let size_b = b.width * b.height;
            if (size_a < size_b) return 1;
            if (size_a > size_b) return -1;
            return 0;
        });

        final = boundsThatfit[0];

        return this.centerBounds(final, outer);
    }

}